import {Fragment} from "react";
/** Render plain documentation safely while making explicit http(s) links usable. */
export function LinkifiedText({text}:{text:string}){
 const parts=text.split(/(https?:\/\/[^\s<]+)/gi);
 return <p>{parts.map((part,index)=>/^https?:\/\//i.test(part)?<a key={index} href={part} target="_blank" rel="noreferrer">{part}</a>:<Fragment key={index}>{part}</Fragment>)}</p>;
}
